/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCreationRequest
 */
export interface FreelancerCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof FreelancerCreationRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCreationRequest
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCreationRequest
     */
    lastname: string;
}

/**
 * Check if a given object implements the FreelancerCreationRequest interface.
 */
export function instanceOfFreelancerCreationRequest(value: object): value is FreelancerCreationRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    return true;
}

export function FreelancerCreationRequestFromJSON(json: any): FreelancerCreationRequest {
    return FreelancerCreationRequestFromJSONTyped(json, false);
}

export function FreelancerCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
    };
}

export function FreelancerCreationRequestToJSON(value?: FreelancerCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

